<template>
  <div>
    <Header />
    <!-- End Header -->

    <Slider />
    <!-- End Slider -->

    <About />
    <!-- End About -->

    <div class="waxon_tm_portoflio" id="portfolio">
      <Portfolio />
    </div>
    <!-- End Portfolio -->

    <div class="waxon_tm_contact" id="contact">
      <div class="bg_image"></div>
      <div class="container">
        <div class="contact_inner">
          <div class="waxon_tm_main_title">
            <div
              class="title"
              v-scroll-reveal="{ delay: 20, distance: '20px' }"
            >
              <h3>Get in Touch<span class="bg">Contact</span></h3>
            </div>
          </div>
          <div class="desc" v-scroll-reveal="{ delay: 30, distance: '20px' }">
            <p>
              I look forward to meeting you!
            </p><br>
            <p>
              Feel free to email me at
                <b>raryanatkins59@gmail.com</b>
              or connect on socials!
            </p>
          </div>
          <div class="wrapper">
            <div class="left" v-scroll-reveal="{ delay: 40 }">
              <Social />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End social -->

    <Footer />

    <!-- End End Footer -->
  </div>
</template>

<script>
import Header from "../../components/Header.vue";
import Slider from "../../components/slider/Slider.vue";
import About from "../../components/about/About.vue";
import Portfolio from "../../components/portfolio/Portfolio.vue";
import Social from "../../components/Social.vue";
import Footer from "../../components/Footer.vue";
export default {
  components: {
    Header,
    Slider,
    About,
    Portfolio,
    Social,
    Footer,
  },
};
</script>

<style lang="scss" scoped></style>
